module.exports = __webpack_public_path__ + "static/media/shopify-logo.0d41f5d0.png";